import type { PageType } from "@/app/hooks/use-app-state";

export const createSettingsNavigator = (
  setNavigatedFromMenu: (value: boolean) => void,
  navigateToPage: (page: PageType) => void
) => {
  const navigateToSubPage = (page: PageType) => {
    setNavigatedFromMenu(false);
    navigateToPage(page);
  };

  return {
    toPasswordSecurity: () => navigateToSubPage("password-security"),
    toLanguageRegion: () => navigateToSubPage("language-region"),
    toAbout: () => navigateToSubPage("about"),
    toTerms: () => navigateToSubPage("terms"),
    toPrivacyPolicy: () => navigateToSubPage("privacy-policy"),
    /** LGPD: exportar dados, exclusão de conta (página Privacidade). */
    toPrivacy: () => navigateToSubPage("privacy"),
    toAccountDeletionPublic: () => navigateToSubPage("account-deletion"),
  };
};